import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Pendências de Lançamento',
    path: 'pendencias-lancamento',
    name: 'pendenciaslancamentogrid',
    component: () => import('@/views/gestao/pendencias-lancamento/Index.vue'),
    goesToMenu: true,
    meta: {
      // Tela aberta para quem lança, não só para o administrativo. A API recorta as pendências
      // pelas obras e tipos de fornecimento do usuário (MtvGesPendenciasLancamentoController).
      permissions: [EPermissoes.Administrativo, EPermissoes.Lancamento],
      grupos: [],
      escopoObra: 'global'
    }
  }
];
